export function parsePeriod(periodStr) {
    let d = periodStr.substring(0, 10)
    let week = new Date(d).getDay()
    let weekstr
    switch (week) {
        case 0: {
            weekstr = "周日"
            break
        }
        case 1: {
            weekstr = "周一"
            break
        }
        case 2: {
            weekstr = "周二"
            break
        }
        case 3: {
            weekstr = "周三"
            break
        }
        case 4: {
            weekstr = "周四"
            break
        }
        case 5: {
            weekstr = "周五"
            break
        }
        case 6: {
            weekstr = "周六"
            break
        }

    }
    return weekstr
}